import {
  Button,
  Grid,
  makeStyles,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import React from 'react'
import WarningIcon from '@material-ui/icons/Warning'
import { FormattedMessage } from 'react-intl'
import { useRouter } from 'next/router'

const useStyles = makeStyles((theme: Theme) => {
  return {
    warningIcon: {
      color: theme.palette.grey[400],
      margin: theme.spacing(0, 4),
    },
    desktopRequiredText: {
      fontSize: theme.typography.pxToRem(28),
      paddingBottom: theme.spacing(3),
    },
    buttonText: {
      color: 'white',
    },
    iconContainer: {
      marginBlock: theme.spacing(7),
    },
    desktopRequiredContainer: {
      padding: theme.spacing(6),
    },
    buttonStyle: {
      padding: theme.spacing(1, 4),
      width: 'fit-content',
    },
    buttonContainer: {
      width: '100%',
      marginTop: theme.spacing(25),
      display: 'flex',
      justifyContent: 'center',
    },
  }
})

const DesktopRequired = () => {
  const classes = useStyles()
  const router = useRouter()
  const handleBackClick = () => {
    router.back()
  }
  const theme = useTheme()
  const isTabletUp = useMediaQuery(theme.breakpoints.up('sm')) === true
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      className={classes.desktopRequiredContainer}
    >
      <Grid item className={classes.iconContainer}>
        <WarningIcon fontSize="large" className={classes.warningIcon} />
      </Grid>
      <Grid item>
        <Typography className={classes.desktopRequiredText}>
          <FormattedMessage
            id="DESKTOP_REQUIRED"
            defaultMessage="Desktop Required"
          />
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="subtitle2">
          <FormattedMessage
            id="DESKTOP_REQUIRED_MESSAGE"
            defaultMessage="This feature is currently only available on desktop. Please switch to the desktop experience to access it."
          />
        </Typography>
      </Grid>
      <Grid item className={classes.buttonContainer}>
        <Button
          color="primary"
          variant="contained"
          fullWidth
          onClick={handleBackClick}
          className={isTabletUp ? classes.buttonStyle : ''}
        >
          <Typography className={classes.buttonText}>
            <FormattedMessage id="BACK" defaultMessage="Back" />
          </Typography>
        </Button>
      </Grid>
    </Grid>
  )
}

export default DesktopRequired
